exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.short-description-box[data-v-67f29d2d] {\n  height: 2.2em;\n  line-height: 1.1;\n  overflow: hidden;\n}\n.vaccine-section[data-v-67f29d2d] {\n  font-size: 86%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-67f29d2d","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/recommend/components/RecommendProfessional.vue
// module id = 1473
// module chunks = 0